import {
  VISIBLE_STATE,
  MEMBER_STATUS
} from "./StateConstants.ts";


export interface MemberModel {
  objectId?: string
  updatedAt?: Date
  createdAt?: Date
  name?: string
  surname?: string
  about?: string
  email?: string
  organization?: string
  position?: string
  phoneNumber?: string
  avatar?: string
  isNew?: boolean
  hidden?: boolean
  password?: string
  passwordSet?: boolean
  newMembersOrder?: number
  membershipValidStart?: Date
  membershipValidUntil?: Date
  isSuspend?: boolean
  memberType?: string
  abbreviatedBio?: string
  hiddenState: string
  memberStatus: string
  memberCategory?: string
  gender?: string // "male" | "female"
}

export class Member implements MemberModel {
  objectId?: string
  updatedAt?: Date
  createdAt?: Date
  name?: string
  surname?: string
  about?: string
  email?: string
  organization?: string
  position?: string
  phoneNumber?: string
  avatar?: string
  isNew?: boolean
  hidden?: boolean
  password?: string
  passwordSet?: boolean
  newMembersOrder?: number
  membershipValidStart?: Date
  membershipValidUntil?: Date
  isSuspend?: boolean
  memberType?: string
  abbreviatedBio?: string
  hiddenState: string
  memberStatus: string
  memberCategory?: string
  gender?: string

  constructor(
    objectId = undefined,
    updatedAt = undefined,
    createdAt = undefined,
    name = undefined,
    surname = undefined,
    about = undefined,
    email = undefined,
    organization = undefined,
    position = undefined,
    phoneNumber = "+44 ",
    avatar = undefined,
    isNew = false,
    hidden = false,
    password = "",
    passwordSet = false,
    newMembersOrder = 1,
    membershipValidStart = undefined,
    membershipValidUntil = undefined,
    isSuspend = undefined,
    memberType = undefined,
    abbreviatedBio = undefined,
    hiddenState = "",
    memberStatus = "",
    memberCategory = undefined,
    gender = undefined
  ) {
    this.objectId = objectId
    this.updatedAt = updatedAt
    this.createdAt = createdAt
    this.name = name
    this.surname = surname
    this.about = about
    this.email = email
    this.organization = organization
    this.position = position
    this.phoneNumber = phoneNumber
    this.avatar = avatar
    this.isNew = isNew
    this.hidden = hidden
    this.password = password
    this.passwordSet = passwordSet
    this.newMembersOrder = newMembersOrder
    this.membershipValidStart = membershipValidStart
    this.membershipValidUntil = membershipValidUntil
    this.isSuspend = isSuspend
    this.memberType = memberType
    this.abbreviatedBio = abbreviatedBio
    this.hiddenState = hiddenState
    this.memberStatus = memberStatus
    this.memberCategory = memberCategory
    this.gender = gender
  }

  static convertFromParseObject(parseObject: any): MemberModel {
    const isSuspend = parseObject?.get("isSuspend")
    const passwordSet = parseObject?.get("passwordSet")
    const memberStatus = isSuspend ? MEMBER_STATUS.SUSPENDED : (passwordSet ? MEMBER_STATUS.ACTIVE : MEMBER_STATUS.INACTIVE)
    const niddenState = parseObject?.get("hidden") ? VISIBLE_STATE.PRIVATE : VISIBLE_STATE.PUBLIC

    return new Member(
      parseObject?.id,
      parseObject?.updatedAt,
      parseObject?.createdAt,
      parseObject?.get("name"),
      parseObject?.get("surname"),
      parseObject?.get("about"),
      parseObject?.get("email") ?? parseObject?.get("visibleEmail"),
      parseObject?.get("organization"),
      parseObject?.get("position"),
      parseObject?.get("phoneNumber"),
      parseObject?.get("avatar")?.url(),
      parseObject?.get("isNew"),
      parseObject?.get("hidden"),
      "",
      parseObject?.get("passwordSet"),
      parseObject?.get("newMembersOrder"),
      parseObject?.get("membershipValidStart"),
      parseObject?.get("membershipValidUntil"),
      parseObject?.get("isSuspend"),
      parseObject?.get("memberType"),
      parseObject?.get("abbreviatedBio"),
      niddenState,
      memberStatus,
      parseObject?.get("memberCategory"),
      parseObject?.get("gender")
    )
  }
}
